import { normaliseSignageDisplayUrl } from './app/features/signage/kernel/signage-display-url';
import {
  captureVisitorLinkKey,
  isVisitorPagePath,
} from './app/features/visitors/visitor-form/visitor-page-link';
import { normaliseOAuthReturnUrl } from './app/features/settings/pages/integrations/oauth-return.util';
import { takeLoginHandoffFromAddress } from './app/core/utils/login-return-path';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { ensureMapboxCss } from './app/core/utils/mapbox-css';

// Recover old saved links before the router can send them to the admin shell.
const displayUrl = normaliseSignageDisplayUrl(window.location.href, window.location.origin);
if (displayUrl !== window.location.href) window.history.replaceState(null, '', displayUrl);

// The API's Microsoft 365 OAuth callback redirects to `/#/settings/integrations…`;
// this app routes paths, so give the router the path form.
const oauthReturnUrl = normaliseOAuthReturnUrl(window.location.href, window.location.origin);
if (oauthReturnUrl !== window.location.href) window.history.replaceState(null, '', oauthReturnUrl);

// The visitor's own page: hold its link key in memory and take it out of the
// address bar BEFORE the router, the first pageview or anything else reads the URL.
if (isVisitorPagePath(window.location.pathname)) captureVisitorLinkKey();

// login-web's sign-in handoff (`#rt=<refresh token>&t=<tenant>`): the same, for
// the auth guard. PostHog's init records the address, so it must be gone first.
takeLoginHandoffFromAddress();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

// Warm the (non-injected, unhashed) mapbox-gl stylesheet after first paint so
// the campus map tab renders instantly when opened. Best-effort: the map boot
// path also calls ensureMapboxCss() directly, and this resolves even on error
// so a blocked stylesheet never wedges startup. (zone-flags — the wheel-unpatch
// mapbox needs for preventDefault — is loaded via angular.json polyfills, ahead
// of zone.js, since ordering there is guaranteed and a main.ts import is too late.)
const warmMapboxCss = (): void => {
  const idle =
    (window as Window & { requestIdleCallback?: (cb: () => void) => void })
      .requestIdleCallback ?? ((cb: () => void) => setTimeout(cb, 1500));
  idle(() => void ensureMapboxCss());
};
if (document.readyState === 'complete') warmMapboxCss();
else window.addEventListener('load', warmMapboxCss, { once: true });
